import { useNavigate } from "react-router-dom"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useState, useEffect } from 'react';
import { database } from '../../config';
import { ref, onValue, query, orderByChild, equalTo } from 'firebase/database';
import { Review } from '../../types/review';
import { showToast } from '../../components/CustomToast';
import { StarIcon } from '@heroicons/react/24/solid';

import { Badge } from "../../components/Badge"
import Card from "../../components/Card"
import FAQItem from "../../components/FAQItem"
import "./index.css"

const mainReviews = [
    {
        name: 'Regan Mascord',
        review: 'I rented my betting account very easy process and great service'
    },
    {
        name: 'Alex Prestia',
        review: 'Easy way to make money off accounts you don`t use 👌'
    },
    {
        name: 'Adriian McGeoff',
        review: 'good karma betting, is defs a good reliable and paying company! good on you guys, 😀'
    },
    {
        name: 'Charlie Moore',
        review: 'Can`t stress how easy it is, money comes in quick, just an easy way to make a quick buck couldn`t recommend more'
    },
    {
        name: 'Kalab Jack',
        review: 'Quick fast and very trustworthy would 100% recommended these guys over anyone'
    },
    {
        name: 'Aniqu Williams',
        review: 'Quick and easy application process, less than 5 mins. Had a reply and funds transferred in the same day. Highly recommend'
    },
    {
        name: 'Rodney Fletcher',
        review: 'Easy to deal with, paid instantly very happy!'
    },
    {
        name: 'Kgh Gajj',
        review: 'amazing service got my money!'
    },
    {
        name: 'James Lee',
        review: 'Great service! Easy communication and great blokes.. highly recommended'
    },
    {
        name: 'Xuan Yu',
        review: 'Good Karma Betting, is very fast and reliable company! if I had 10 stars to click, they definitely deserve it'
    }
]

// Helper function to format the timestamp
const formatTimestamp = (id: string) => {
    try {
        // Extract timestamp from Firebase key (assuming it's in the key)
        const timestamp = parseInt(id.split('-')[0]);
        if (isNaN(timestamp)) return '';

        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (error) {
        return '';
    }
};

export default function Home() {
    const navigate = useNavigate();

    const [reviews, setReviews] = useState<Review[]>([]);
    const [reviewCount, setReviewCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [topReviewers, setTopReviewers] = useState<string[]>([]);

    useEffect(() => {
        // Reference to the reviews node in Firebase
        const reviewsRef = ref(database, 'reviews');

        // Query for 5-star reviews
        const reviewsQuery = query(
            reviewsRef,
            orderByChild('value'),
            equalTo(5)
        );

        // First get total count
        onValue(reviewsRef, (snapshot) => {
            const count = snapshot.size || 0;
            setReviewCount(count);
        });

        // Then get reviews with selfies
        const unsubscribe = onValue(reviewsQuery, (snapshot) => {
            try {
                const data = snapshot.val();
                if (data) {
                    // Convert the object of reviews into an array and filter for non-empty selfies
                    const reviewsArray = Object.entries(data)
                        .map(([key, value]: [string, any]) => ({
                            id: key,
                            content: value.content,
                            writer: value.writer,
                            value: value.value,
                            selfie: value.selfie || ''
                        }))
                        .filter(review => review.selfie && review.selfie !== "" && review.selfie !== "undefined" && !review.selfie.includes("undefined"))
                        .slice(0, 10);

                    // Sort reviews by most recent first
                    const sortedReviews = reviewsArray.sort((a, b) => a.id.localeCompare(b.id));

                    setReviews(sortedReviews);

                    // Get unique selfies for the avatar display
                    const uniqueSelfies = Array.from(new Set(
                        sortedReviews.map(review => review.selfie)
                    )).slice(0, 6); // Get up to 6 unique selfies

                    setTopReviewers(uniqueSelfies);
                } else {
                    setReviews([]);
                    setTopReviewers([]);
                }
            } catch (error) {
                console.error('Error fetching reviews:', error);
                showToast.error('Failed to load reviews');
            } finally {
                setLoading(false);
            }
        }, (error) => {
            console.error('Error fetching reviews:', error);
            showToast.error('Failed to load reviews');
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const handleRentClick = () => {
        navigate('/register/customer');
    }

    const handleContactClick = () => {
        window.open("https://www.facebook.com/profile.php?id=61573878153297", "_blank");
    }

    return (
        <div>
            <div className="sell-section">
                <div className="sell-wrap">
                    <img alt="effect" src="./assets/effect-1.png" className="hidden md:block sm:absolute right-0 bottom-0 w-[65%]" />
                    <div className="py-[175px] flex items-center">
                        <div className="hero-content">
                            <p className="hero-text-1">Sell Your Sports Betting</p>
                            <p className="hero-text-1">Accounts.</p>
                            <div className="flex gap-[16px] sm:gap-9 items-center">
                                <p className="hero-text-2">Earn $200 Today</p>
                            </div>
                            <p className="hero-text-3">We'll buy your betting accounts for $200.</p>
                            <p className="hero-text-3">Safe. Secure. Hassle-free.</p>
                            <div className="mt-[14.5px] sm:mt-8 gap-[9.51px] sm:gap-[21px] flex flex-col sm:flex-row items-start sm:items-center">
                                <button onClick={handleRentClick} className="btn-1">Rent your account to us</button>
                                <div className="flex items-center">
                                    {[
                                        'https://i.pravatar.cc/150?img=5',
                                        'https://i.pravatar.cc/150?img=9',
                                        'https://i.pravatar.cc/150?img=16',
                                        'https://i.pravatar.cc/150?img=20',
                                        'https://i.pravatar.cc/150?img=32',
                                        'https://i.pravatar.cc/150?img=36'
                                    ].map((url, index) => (
                                        <img
                                            key={`hero-review-${index}`}
                                            alt="reviewer"
                                            src={url}
                                            className="avatar w-[32px] h-[32px] rounded-full object-cover -ml-2 first:ml-0 border-2 border-white"
                                        />
                                    ))}
                                    <p className="ml-3 sm:ml-6 text-[10.86px] xl:text-xl 2xl:text-[24px] text-white font-bold">+{reviewCount} Reviews</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex sm:absolute transform right-5 lg:right-8 2xl:right-[120px] top-1/2 -translate-y-[45%] px-3">
                        <img src="./assets/horse-race.png" className="hero-img" alt="horse-race" />
                    </div>
                </div>
            </div>
            <div className="work-section">
                <div className="relative py-[33px] md:py-[108px] px-[20px] flex items-center justify-center flex-col -mt-[115px] sm:mt-0 overflow-hidden">
                    <p className="work-title">How it works</p>
                    <div className="pt-[98px] pb-[70px]">
                        <img alt="work step" src="./assets/how-it-works.png" className="hidden md:block" />
                        <img alt="work step" src="./assets/mobile-how-works.png" className="block md:hidden" />
                    </div>
                    <button onClick={handleRentClick} className="btn-start">Get Started</button>
                    <img alt="effect-2" src="./assets/effect-2.png" className="absolute block bottom-5 sm:-bottom-16 -z-10 -rotate-[10deg] sm:rotate-0 h-[545px] sx:h-auto sm:w-auto" />
                </div>
            </div>
            <div className="referral-section">
                <div className="pt-[47px] md:pt-[87px] flex flex-col items-center max-w-[1160px]">
                    <p className="referral-title">Our Referral Program</p>
                    <p className="referral-subtitle">Introducing our Referral Program Your ticket to earning <span className="text-[21px] md:text-[48px] text-[#FFB91F] font-semibold">$150</span> For each Male Successful Referral and <span className="text-[21px] md:text-[48px] text-[#FFB91F] font-semibold">$100</span> For each Female Successful Referral</p>
                    <div className="mt-[81px] md:mt-8 flex flex-col md:flex-row gap-[28px] md:gap-[50px] px-2">
                        <Card
                            img="./assets/speaker.png"
                            text={<div>
                                <p className="text-[11.48px] leading-[18px] font-medium text-[#010F20] md:text-[20px] md:leading-[32px] text-center">Tell your friends and family they can make $200 cash easily by signing up with GoodKarmaBetting.</p>
                            </div>}
                            title="1. Spread the Word"
                        />
                        <Card
                            img="./assets/money.png"
                            text={<div>
                                <p className="text-[11.48px] leading-[18px] font-medium text-[#010F20] md:text-[20px] md:leading-[32px] text-center">Once their application is approved, we'll send you up to $150 for each person you referred.</p>
                            </div>}
                            title="2. Cash In!"
                        />
                    </div>
                    <div className="px-2 mt-[34.45px] md:mt-[60px] w-full flex justify-center">
                        <button className="outline-btn">
                            Get Referral Link
                        </button>
                    </div>
                </div>
            </div>
            <div className="review-section">
                <div className="review-wrap">
                    <p className="review-title">Our clients rated us 4.1/5, listen to what they had to say</p>
                    {loading ? (
                        <div className="flex justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
                        </div>
                    ) : (
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={30}
                            loop={reviews.length > 3}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Pagination, Navigation]}
                            className="mySwiper"
                            breakpoints={{
                                768: {
                                    slidesPerView: 2,
                                },
                                1280: {
                                    slidesPerView: 3,
                                }
                            }}
                        >
                            {reviews.map((review, index) => (
                                <SwiperSlide key={review.id} className="flex justify-center">
                                    <div className="bg-white rounded-[20px] p-8 h-[300px] md:w-full flex flex-col justify-between">
                                        {/* Review content at the top */}
                                        <p className="text-[18px] text-center font-medium mb-6 line-clamp-4 overflow-hidden">
                                            {mainReviews[index].review}
                                        </p>

                                        {/* Bottom section with name, rating and date */}
                                        <div className="flex flex-col items-center">
                                            <h3 className="text-[20px] font-bold mb-2 truncate max-w-full">
                                                {mainReviews[index].name}
                                            </h3>
                                            <div className="flex items-center justify-center mb-2">
                                                {[...Array(5)].map((_, index) => (
                                                    <StarIcon
                                                        key={index}
                                                        className={`h-6 w-6 ${index < review.value
                                                            ? 'text-[#00BA9D]'
                                                            : 'text-gray-200'
                                                            }`}
                                                    />
                                                ))}
                                            </div>
                                            <span className="text-gray-500 text-sm">
                                                {formatTimestamp(review.id)}
                                            </span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                    <div className="flex flex-col items-center mt-[49px] md:mt-[59px]">
                        <div className="flex">
                            {[
                                'https://i.pravatar.cc/150?img=12',
                                'https://i.pravatar.cc/150?img=15',
                                'https://i.pravatar.cc/150?img=21',
                                'https://i.pravatar.cc/150?img=26',
                                'https://i.pravatar.cc/150?img=33',
                                'https://i.pravatar.cc/150?img=37'
                            ].map((url, index) => (
                                <img
                                    key={`review-${index}`}
                                    alt="reviewer"
                                    src={url}
                                    className="avatar w-[32px] h-[32px] rounded-full object-cover -ml-2 first:ml-0 border-2 border-white"
                                />
                            ))}
                        </div>
                        <p className="text-[20px] md:text-[24px] font-semibold text-white">+{reviewCount} Reviews</p>
                    </div>
                </div>
            </div>
            <div className="faq-section">
                <div className="faq-wrap w-full">
                    <div className="bg-[#d1b98b] px-2 md:px-[90px] py-[0] md:py-[66px] w-full">
                        <p className="text-[24px] md:text-[40px] leading-[32px] md:leading-[70px] font-medium text-white text-center">FAQ</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-[14px] mt-[24px]">
                            <FAQItem
                                question="How does the $200 payout work?"
                                answer={`Express your interest by filling out the form. Takes only a few minutes.Upon creating and verifying your betting accounts, we'll send $200 to your specified bank via PayID within the same day normally.Payment is issued only upon account approval. Submitting the form alone doesn't warrant payment.`}
                            />
                            <FAQItem
                                question="No sports betting accounts?"
                                answer="No problem! We create the accounts for you. No active involvement on your behalf necessary."
                            />
                            <FAQItem
                                question="How do I know this isn't a scam?"
                                answer="We foster trust through clear communication, robust security measures, and transparency. Ask us anything. Our Terms & Conditions provide a detailed outline of the agreement safeguarding both parties. You can explore testimonials on our site for firsthand accounts of our reliability. For any queries, do not hesitate to get in touch with us."
                            />
                            <FAQItem
                                question="What can i get cash back on?"
                                answer="We offer cashback on various betting accounts and platforms. Contact our support team for a detailed list of eligible accounts and current rates."
                            />
                            <FAQItem
                                question="Is this legal?"
                                answer="Absolutely! Selling sports accounts through our program is entirely legal. We stay current with all relevant regulations and diligently follow them. Our Terms and Conditions are designed with full compliance in mind, ensuring that our operations are always above board."
                            />
                            <FAQItem
                                question="Is my personal information safe and secure?"
                                answer="Your privacy and security are our top priorities. We employ industry-standard encryption and security measures.

All personal data is handled in accordance with privacy laws and our strict internal policies.

We never share your information with unauthorized third parties."
                            />
                            <FAQItem
                                question="Which betting accounts do you create?"
                                answer="We primarily create and purchase accounts from TAB, Sportsbet, and Betr."
                            />
                            <FAQItem
                                question="Why do we want your accounts?"
                                answer={`We use a profitable strategy called "matched betting" that leverages free bets and promotions. By acquiring your accounts, we access these promos to fuel our betting approach. Feel free to research "matched betting" for more details.`}
                            />
                        </div>
                    </div>
                    <button onClick={handleContactClick} className="outline-btn mt-[27px] md:mt-[82px]">Contact Us</button>
                </div>
            </div>
        </div>
    )
}